var render = function render(){var _vm=this,_c=_vm._self._c;return _c('iframe',{attrs:{"loading":"lazy","width":"100%","height":"100%","src":_vm.option.attribute.url}})
}
var staticRenderFns = []

export { render, staticRenderFns }